import { toTitleCase } from "../lib/string.lib";
import clsx from 'clsx';

export const StatCard: React.FC<{
  title: string;
  value: number | string;
  icon: React.ComponentType<any>;
  description?: string;
  change?: string;
  changeType?: 'increase' | 'decrease';
  skipTitleCase?: boolean;
  valueAlign?: 'left' | 'right';
  compact?: boolean;
  dense?: boolean;
  rounded?: boolean;
}> = ({
  title,
  value,
  icon: Icon,
  description,
  change,
  changeType,
  skipTitleCase = false,
  valueAlign = 'right',
  compact = false,
  dense = false,
  rounded = false,
}) => {
  return (
    <div
      className={clsx(
        'bg-white overflow-hidden shadow transition-all duration-200 border border-gray-200',
        dense ? 'min-h-[96px]' : 'min-h-[120px]',
        rounded && 'rounded-md'
      )}
    >
      <div className={clsx('h-full flex flex-col', dense ? 'p-3' : 'p-6')}>
        <div className="flex items-start space-x-3 mb-2">
          <div className="flex-shrink-0 text-gray-400">
            <Icon className="h-5 w-5" />
          </div>
          <div className="flex-1">
            <h3
              className={clsx(
                'text-gray-900',
                compact ? 'text-sm font-semibold' : 'text-base font-medium'
              )}
            >
              {skipTitleCase ? title : toTitleCase(title)}
            </h3>
            {description && (
              <p className="text-sm text-gray-500 mt-1">{description}</p>
            )}
          </div>
        </div>

        <div className={clsx('mt-auto', valueAlign === 'left' ? 'text-left' : 'text-right')}>
          <div
            className={clsx(
              'font-bold text-gray-900',
              compact ? 'text-3xl' : 'text-4xl'
            )}
          >
            {value}
          </div>
          {change && (
            <div className={`text-sm font-medium mt-1 ${changeType === 'increase' ? 'text-green-600' : 'text-red-600'}`}>
              {change}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
